import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';
import { useGetStudySubjectsQuery } from '../../../../../../redux/services/study_subjects.jsx';
import {
  useGetQuizQuery,
  useGetQuizzesQuery,
  useSaveQuizMutation,
} from '../../../../../../redux/services/quizzes.jsx';
import QuizzesForm from './QuizzesForm.jsx';

const QuizzesEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava kvízu') + ' - FRI CMS'
      : t('Pridanie kvízu') + ' - FRI CMS';
  }, []);

  const { saveSuccess } = useToastMessages();

  const { data: quizDetail, isLoading: isDetailLoading } = useGetQuizQuery(id, {
    skip: !isEdit,
  });
  const { data: subjects, isLoading: isSubjectsLoading } =
    useGetStudySubjectsQuery();

  const [saveQuiz, { isSuccess: isSaveSuccess }] = useSaveQuizMutation();
  const { refetch } = useGetQuizzesQuery();

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsQuizzes);
      refetch();
    }
  }, [isSaveSuccess]);

  if ((isEdit && isDetailLoading) || isSubjectsLoading) {
    return <Spinner />;
  }

  const initials = {
    title: undefined,
    description: undefined,
    study_subject_id: undefined,
    ...(quizDetail || {}),
  };

  const onSubmit = (values) => {
    // For create, omit id; for edit, include id in mutation
    const payload = { body: values };
    if (isEdit) payload.id = id;
    saveQuiz(payload);
  };

  const title = isCreate ? t('Pridanie kvízu') : t('Úprava kvízu');

  return (
    <>
      <AppBarCMS
        title={title}
        backUrl={routes.cmsQuizzes}
        backUrlTooltip={t('Kvízy')}
        permissionsBasic="quizzes"
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('Obsah')}>
          <QuizzesForm
            initials={initials}
            onSubmit={onSubmit}
            subjectOptions={subjects || []}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default QuizzesEdit;
